import * as DOMUtils from "history/DOMUtils";
import type { AbortableRequestStatus } from "../../../common-deprecated/types/CommonTypes";
import { RequestStatusEnum } from "../../../common-deprecated/types/CommonTypes";
import type { AbortableFetchFnReturnType } from "../../../common-deprecated/utils/backendFetch";

export const isRequestPossible = (status: AbortableRequestStatus, refresh: boolean = false): boolean => {
    return !!(
        status === RequestStatusEnum.Idle ||
        (DOMUtils.canUseDOM && status === RequestStatusEnum.Aborted) ||
        (refresh && status === RequestStatusEnum.Complete)
    );
};

export const getRequestFailureStatus = <T>(result: AbortableFetchFnReturnType<T>): AbortableRequestStatus => {
    return result.aborted ? RequestStatusEnum.Aborted : RequestStatusEnum.Error;
};
